import { Type } from 'class-transformer'
import { Entity } from '..'
import { Rol } from '@/entities/public/Rol'

export class Roles extends Entity {
  @Type(() => Rol)
  rol: Rol;
}
